import "./Dashboard.scss";
import NewsLR from "../../components/NewsLR/NewsLR";
import NewsTD from "../../components/NewsTD/NewsTD";
import { useUser } from "../../context/UserProvider";
import { useEffect, useState } from "react";
import { getNews } from "../../service/dashboard";

const Dashboard = () => {

    const { setErrorState } = useUser();
    const [ newsData, setNewsData ] = useState([]);
    useEffect(() => {
        getNews()
            .then(response => {
                setNewsData(response.data.tableData);
            })
            .catch(error => {       
                setErrorState("Error fetching news articles")
            });
    }, []);

    return <>
        <div className="dashboard">
            
            <div className="dashboard-header">
                {newsData.map((item, index) => (
                    <NewsTD key={index} news={item} />
                ))}
            </div>
             <div className="dashboard-header">
                {newsData.map((item, index) => (
                    <NewsLR key={index} news={item} />
                ))}
            </div>
            {/* <div>
                <iframe 
                    width="210" 
                    height="315" 
                    src="https://www.youtube.com/embed/a6cW9Nd9Dmk" 
                    title="Muzaffarnagar में भाकियू तोमर के साथ हो गया ये बड़ा मामला |" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin" 
                    allowfullscreen></iframe>
            </div> */}
        </div>
    </>
}

export default Dashboard;